
// 插件路由
const signup = () => import(/* webpackChunkName: "signup" */ '~/addon/signup/pages/signup.vue')

const routes = [
	{ 
        path: '/signup', 
        component: signup 
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/signup/router/index.js